export class DeleteOrderBillItemModel {
  public orderBillItemId: string;
  public pin: string;
  public venueId: string;
  public employeeId: string;
  public quantity: number;

}
